import { render } from "./VInput.vue?vue&type=template&id=056f49e6"
import script from "./VInput.vue?vue&type=script&lang=js"
export * from "./VInput.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__